// extracted by mini-css-extract-plugin
export default {"brand":"index_brand_TOh69","brandBox":"index_brandBox_Zdw5q","brandPic":"index_brandPic_XsHWP"};